import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CheckedIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon
      viewBox="20 16 20 20"
      {...props}
      htmlColor={props.htmlColor || Color.PrimaryMain}
    >
      <rect x="20" y="16" width="20" height="20" rx="5" />
      <path
        d="M25 25.4783L29.8148 30L35 22"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </MuiSvgIcon>
  );
}
export default CheckedIcon;
